import { DocumentPage } from '@/components/DocumentPage'
import styles from './PrivacyPage.module.css'

const processingPurposes = [
  {
    subject: 'Посетители сайта и приложения-бота',
    purpose: 'Обеспечение корректной работы сайта, аналитика, защита от атак',
    data: 'IP-адрес, данные о местоположении, тип устройства и браузера, cookie-файлы',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Пользователи, создавшие личный кабинет',
    purpose: 'Предоставление доступа к персонализированному разделу сайта и/или приложения-бота, истории заказов, настройкам',
    data: 'ФИО, e-mail, номер телефона, история заказов, IP, настройки аккаунта',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Пользователи, оформившие заказ',
    purpose: 'Принятие, обработка и доставка заказа, исполнение договора',
    data: 'ФИО, дата, месяц и год рождения, номер телефона, e-mail, адрес доставки, сведения о заказе, комментарии',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Пользователи, согласившиеся на рекламную рассылку',
    purpose: 'Рассылка информационных и рекламных материалов',
    data: 'Имя, e-mail, номер телефона, id в мессенджерах (если предоставлены)',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Пользователи, оставившие заявки или сообщения',
    purpose: 'Связь с пользователем по его запросу',
    data: 'Имя, e-mail, телефон, содержание сообщения',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Участники мероприятий, акций, опросов',
    purpose: 'Организация участия, обратная связь, публикация отзывов',
    data: 'ФИО, e-mail, телефон, фото- и видеоизображения, голос, анкета/отзыв',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Контактные лица контрагентов (юр. лиц)',
    purpose: 'Исполнение договорных обязательств, деловая переписка',
    data: 'ФИО, должность, e-mail, номер телефона',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Пользователи, оформившие возврат/рекламацию',
    purpose: 'Обработка возвратов, юридическая отчётность',
    data: 'ФИО, e-mail, телефон, банковские реквизиты',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  },
  {
    subject: 'Кандидаты на вакантные должности',
    purpose: 'Рассмотрение кандидатуры на вакантные должности',
    data: 'ФИО, e-mail, телефон, id в мессенджерах (если предоставлены), резюме, сведения о трудовой деятельности',
    term: 'до достижения цели или отзыва согласия на обработку',
    destroy: 'удаление из базы Оператора'
  }
]

const userRights: Array<{ title: string; text: string }> = [
  {
    title: 'Право на доступ',
    text: 'У вас есть право запросить копию персональных данных, которые есть у Оператора'
  },
  {
    title: 'Право на уточнение',
    text: 'Вы можете попросить Оператора исправить неточные или неполные персональные данные'
  },
  {
    title: 'Право на блокирование и удаление персональных данных',
    text: 'Вы можете запросить удаление данных, которые есть у Оператора относительно вас, за исключением случаев, когда Оператор обязан хранить эти данные по закону'
  },
  {
    title: 'Право на обжалование действий/бездействия Оператора',
    text: 'Если вы считаете, что Оператор обрабатывает ваши персональные данные с нарушением требований законодательства или иным образом нарушает ваши права, вы вправе обжаловать действия/бездействие Оператора в Роскомнадзоре'
  },
  {
    title: 'Право на обжалование решений, принятых на основании исключительно автоматизированной обработки персональных данных',
    text: 'У вас есть право возражать против решений, принятых исключительно на основе автоматизированной обработки ваших персональных данных'
  },
  {
    title: 'Право на отзыв',
    text: 'В любой момент вы можете отозвать свое согласие на обработку данных'
  }
]

/**
 * Страница /privacy — политика конфиденциальности.
 */
export const PrivacyPage = () => (
  <DocumentPage title="Политика конфиденциальности">
    <p className={styles.version}>редакция от 05.02.2026 г.</p>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Оператор</h2>
      <p className={styles.paragraph}>
        Индивидуальный предприниматель Филимонова Полина Дмитриевна
        <br />
        ИНН 544593408683
        <br />
        ОГРНИП 317547600166011
        <br />
        e-mail secretchat.team@gmail.com
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>О чём эта политика?</h2>
      <p className={styles.paragraph}>
        В Политике изложена информация о том, как Оператор обрабатывает ваши персональные данные и
        обеспечивает их безопасность и конфиденциальность.
      </p>
      <p className={styles.paragraph}>
        Во исполнение требований ч. 2 ст. 18.1 Федерального закона «О персональных данных» настоящая
        Политика публикуется в свободном доступе в сети Интернет на ресурсах Оператора.
      </p>
      <p className={styles.paragraph}>
        Ресурсы — электронные ресурсы, в том числе социальные сети, сервисы, платформы, мессенджеры,
        каналы Оператора, зарегистрированные на его имя, сайт.
      </p>
      <p className={styles.paragraph}>
        Из Политики вы узнаете, какие персональные данные получает Оператор и как их использует.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Что такое персональные данные?</h2>
      <p className={styles.paragraph}>
        Персональные данные — это любая информация о человеке (субъекте персональных данных), по
        которым можно его определить. Оператор обрабатывает только те персональные данные, которые
        перечислены в Политике, и которые характеризуют вас как пользователя Ресурсов.
      </p>
      <p className={styles.paragraph}>
        Вы можете дать согласие на обработку персональных данных при использовании Ресурсов,
        заполнении форм обратной связи на Ресурсах и иными способами, предусмотренными Политикой.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        На каком основании Оператор обрабатывает персональные данные?
      </h2>
      <p className={styles.paragraph}>
        Оператор обрабатывает персональные данные на следующих правовых основаниях:
      </p>
      <ul className={styles.list}>
        <li>
          <strong>Согласие субъекта персональных данных</strong> (п. 1 ст. 6 ФЗ «О персональных
          данных») — применяется при обработке данных, передаваемых при использовании Ресурсов,
          заполнении форм обратной связи, подписке на рассылку, публикации отзывов, использовании
          cookie-файлов и иных подобных случаях.
        </li>
        <li>
          <strong>Исполнение договора</strong> (п. 5 ст. 6 ФЗ «О персональных данных») — применяется
          при обработке данных, необходимых для подготовки, заключения и исполнения договоров, а
          также оказания услуг, запрашиваемых пользователем.
        </li>
        <li>
          <strong>Исполнение обязанностей, возложенных законодательством РФ</strong> (п. 2 ст. 6 ФЗ
          «О персональных данных») — применяется при обработке персональных данных, необходимых для
          выполнения требований законодательства, включая налоговый учет, бухгалтерскую отчётность,
          исполнение предписаний государственных органов.
        </li>
        <li>
          <strong>Осуществление законных интересов Оператора</strong> (п. 7 ст. 6 ФЗ «О персональных
          данных») — применяется при обработке данных для обеспечения безопасности сайта,
          предотвращения мошенничества, защиты прав Оператора в случае споров, а также при передаче
          данных третьим лицам для оказания необходимых услуг (например, платёжных сервисов).
        </li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Какие права есть у вас?</h2>
      <p className={styles.paragraph}>
        В любой момент, когда у Оператора есть ваши персональные данные, вы можете воспользоваться
        следующими правами:
      </p>
      <ul className={styles.list}>
        {userRights.map((r) => (
          <li key={r.title}>
            <strong>{r.title}.</strong> {r.text}
          </li>
        ))}
      </ul>
      <p className={styles.paragraph}>
        Вы можете обратиться к Оператору, если захотите уточнить порядок реализации иных прав,
        предусмотренных Федеральным законом «О персональных данных».
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Как Оператор обрабатывает персональные данные?</h2>
      <p className={styles.paragraph}>
        Оператор обрабатывает персональные данные как в цифровой форме (автоматизировано), так и
        вручную (без использования средств автоматизации). При этом Оператор ограничивается
        следующими действиями:
      </p>
      <ul className={styles.list}>
        <li>сбор</li>
        <li>запись</li>
        <li>систематизация</li>
        <li>накопление</li>
        <li>хранение</li>
        <li>уточнение (обновление, изменение)</li>
        <li>извлечение</li>
        <li>использование</li>
        <li>передача (предоставление, доступ)</li>
        <li>блокирование</li>
        <li>удаление</li>
        <li>уничтожение персональных данных</li>
      </ul>
      <p className={styles.paragraph}>
        Оператор может осуществлять хранение информации о фактах регистрации, авторизации, действиях
        пользователей на Ресурсах, а также сведений о предоставленных услугах и транзакциях в
        течение трёх лет с момента совершения таких действий.
      </p>
      <p className={styles.paragraph}>
        Такая информация хранится исключительно в целях исполнения требований законодательства
        Российской Федерации и может быть предоставлена уполномоченным государственным органам по их
        законным запросам.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        В каких целях Оператор обрабатывает ваши персональные данные?
      </h2>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Субъект персональных данных</th>
              <th>Цель обработки</th>
              <th>Обрабатываемые данные</th>
              <th>Срок обработки</th>
              <th>Порядок уничтожения</th>
            </tr>
          </thead>
          <tbody>
            {processingPurposes.map((row) => (
              <tr key={row.subject}>
                <td>{row.subject}</td>
                <td>{row.purpose}</td>
                <td>{row.data}</td>
                <td>{row.term}</td>
                <td>{row.destroy}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h3 className={styles.sectionTitle}>Персональные данные, обрабатываемые платёжными системами</h3>
      <p className={styles.paragraph}>
        Оплата услуг Оператора осуществляется с использованием платёжных сервисов (платёжных
        систем), которые действуют на основании собственных правил, политик конфиденциальности и
        условий обработки персональных данных.
      </p>
      <p className={styles.paragraph}>
        Персональные данные Пользователя, вводимые при совершении платежа (в том числе платёжные
        реквизиты, данные банковских карт, данные платёжных аккаунтов, адрес электронной почты и
        иные сведения, запрашиваемые платёжной системой), обрабатываются соответствующей платёжной
        системой самостоятельно и не передаются Оператору.
      </p>
      <p className={styles.paragraph}>
        Оператор не имеет доступа к указанным персональным данным, не осуществляет их хранение,
        изменение или удаление, а также не имеет технической возможности влиять на порядок их
        обработки платёжными системами.
      </p>
      <p className={styles.paragraph}>
        В случае необходимости изменения, уточнения или удаления персональных данных, обрабатываемых
        платёжной системой, Пользователь обязан обратиться напрямую в соответствующую платёжную
        систему в порядке, установленном её правилами и политикой конфиденциальности.
      </p>
      <p className={styles.paragraph}>
        Оператор не несёт ответственности за обработку персональных данных платёжными системами и
        иными третьими лицами, действующими независимо от Оператора и вне его контроля.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Что такое cookie-файлы?</h2>
      <p className={styles.paragraph}>
        Сайт использует cookie-файлы — небольшие текстовые файлы, которые сохраняются в браузере
        пользователя при посещении сайта. Cookie-файлы позволяют распознавать устройство
        пользователя, обеспечивать корректную работу сайта и улучшать функциональность сервисов.
      </p>

      <h3 className={styles.sectionTitle}>Категории используемых cookie-файлов</h3>
      <ul className={styles.list}>
        <li>
          <strong>Функциональные cookie</strong> — необходимы для базовой работы сайта, включая
          авторизацию, сохранение настроек пользователя, работу корзины и личного кабинета.
        </li>
        <li>
          <strong>Аналитические cookie</strong> — используются для сбора статистики и анализа
          поведения пользователей на сайте. Это позволяет улучшать структуру и содержание сайта.
          Применяются системы веб-аналитики с локализацией хранения данных.
        </li>
        <li>
          <strong>Маркетинговые cookie</strong> — применяются для персонализации контента и показа
          рекламных объявлений на сторонних платформах (при наличии). Используются только при
          наличии отдельного согласия пользователя.
        </li>
      </ul>

      <h3 className={styles.sectionTitle}>Правовое основание обработки</h3>
      <p className={styles.paragraph}>
        Функциональные cookie-файлы обрабатываются на основании законных интересов Оператора
        (обеспечение технической доступности сайта).
      </p>
      <p className={styles.paragraph}>
        Аналитические и маркетинговые cookie-файлы обрабатываются на основании согласия субъекта
        персональных данных, выраженного путём проставления соответствующей отметки (чекбокса) или
        продолжения использования сайта с активацией cookie-баннера.
      </p>

      <h3 className={styles.sectionTitle}>Управление cookie-файлами</h3>
      <p className={styles.paragraph}>
        Пользователь имеет право отключить cookie-файлы в настройках браузера. Это может повлиять на
        корректность отображения отдельных элементов сайта и ограничить доступ к функционалу личного
        кабинета.
      </p>
      <p className={styles.paragraph}>Прочитать об этом подробнее можно по ссылкам: Яндекс.Браузер, Safari, Google Chrome.</p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        Передаёт ли Оператор ваши персональные данные третьим лицам?
      </h2>
      <p className={styles.paragraph}>
        Оператор может передавать персональные данные третьим лицам в объёме, необходимом для
        достижения целей, указанных в настоящей Политике. Такая передача осуществляется только в
        случаях, предусмотренных законом или если это необходимо для оказания услуг пользователю.
      </p>
      <p className={styles.paragraph}>
        Оператор использует услуги третьих лиц, которые обрабатывают персональные данные по его
        поручению, на основании заключённых соглашений о конфиденциальности и обработке персональных
        данных. Это допустимо, если такие лица:
      </p>
      <ul className={styles.list}>
        <li>обеспечивают достаточную защиту данных,</li>
        <li>не используют их в собственных целях,</li>
        <li>действуют строго в рамках поручения.</li>
      </ul>
      <p className={styles.paragraph}>Такими получателями могут быть:</p>
      <ul className={styles.list}>
        <li>поставщики платёжных решений — для приёма оплаты;</li>
        <li>поставщики CRM-систем и платформ email- и push-рассылки;</li>
        <li>поставщики аналитических сервисов (веб-аналитики и бизнес-аналитики);</li>
        <li>хостинг-провайдеры и лица, осуществляющие техническую поддержку сайта и приложений;</li>
        <li>подрядчики, участвующие в процессе доставки, обработки возвратов и иных операциях с заказами;</li>
        <li>лица, предоставляющие доступ к Ресурсам или сопровождающие пользовательский интерфейс;</li>
        <li>
          лица, осуществляющие обеспечение правовой защиты Оператора или третьих лиц при нарушении
          их прав либо угрозе нарушения их прав, включая нарушение законов или регулирующих
          документов;
        </li>
        <li>лица, обеспечивающие доступ пользователей к Ресурсам.</li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Трансграничная передача данных</h2>
      <p className={styles.paragraph}>
        Оператор не осуществляет трансграничную передачу персональных данных на территории
        иностранных государств, не обеспечивающих адекватную защиту прав субъектов персональных
        данных. В случае возникновения такой необходимости (например, использование зарубежных
        хостинг-провайдеров или сервисов аналитики), передача будет осуществляться только при
        наличии письменного согласия субъекта ПДн или в иных случаях, прямо предусмотренных
        федеральным законом.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>
        Как Оператор обеспечивает безопасность персональных данных?
      </h2>
      <p className={styles.paragraph}>
        Оператор защищает персональные данные, которые у него хранятся, от разглашения, полной или
        частичной утраты, а также несанкционированного доступа со стороны третьих лиц.
      </p>
      <p className={styles.paragraph}>
        Безопасность персональных данных обеспечивается реализацией правовых, организационных и
        технических мер, соответствующих угрозам безопасности персональных данных, в соответствии с
        Законодательством РФ.
      </p>
      <p className={styles.paragraph}>
        Хранение и предоставление информации осуществляется на территории Российской Федерации с
        соблюдением требований по информационной безопасности и только в объёме, необходимом для
        исполнения обязанностей Оператора перед государственными органами.
      </p>
      <p className={styles.paragraph}>Организационные меры составляют:</p>
      <ul className={styles.list}>
        <li>назначение лица, ответственного за организацию обработки персональных данных;</li>
        <li>
          ознакомление работников, непосредственно осуществляющих обработку персональных данных, с
          положениями законодательства РФ о персональных данных, и проведение регулярного обучения
          по вопросам защиты персональных данных;
        </li>
        <li>контроль за принимаемыми мерами по обеспечению безопасности персональных данных.</li>
      </ul>
      <p className={styles.paragraph}>Технические меры составляют:</p>
      <ul className={styles.list}>
        <li>
          применение средств защиты информации (межсетевые экраны, системы обнаружения вторжений,
          антивирусная защита), прошедших процедуру оценки соответствия требованиям
          законодательства;
        </li>
        <li>
          использование механизмов шифрования (HTTPS/SSL) для передачи данных между пользователем и
          сайтом;
        </li>
        <li>
          регулярное обновление используемого программного обеспечения для устранения известных
          уязвимостей.
        </li>
      </ul>
      <p className={styles.paragraph}>Если происходит утечка персональных данных, то Оператор:</p>
      <ul className={styles.list}>
        <li>в течение 24 часов уведомляет об этом Роскомнадзор;</li>
        <li>
          в течение 72 часов проводит собственное расследование и уведомляет Роскомнадзор о его
          результатах.
        </li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Что Оператор не проверяет?</h2>
      <p className={styles.paragraph}>
        Оператор не может проверить и поэтому доверяет Вам в том, что вы:
      </p>
      <ul className={styles.list}>
        <li>обладаете полной дееспособностью;</li>
        <li>предоставили собственные достоверные персональные данные.</li>
      </ul>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Как связаться с Оператором?</h2>
      <p className={styles.paragraph}>
        По любым вопросам в отношении обработки персональных данных вы можете обратиться к Оператору
        по e-mail secretchat.team@gmail.com. При обращении укажите своё имя и контакты для обратной
        связи. Оператор ответит на ваше обращение не позднее 10 рабочих дней с момента его
        получения.
      </p>
    </section>

    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Изменение Политики</h2>
      <p className={styles.paragraph}>
        Оператор может обновить условия Политики на основании следующего:
      </p>
      <ul className={styles.list}>
        <li>изменения в законодательстве;</li>
        <li>введение новых технологий или методов обработки персональных данных;</li>
        <li>изменения в структуре или бизнес-процессах Оператора;</li>
        <li>
          внедрение новых продуктов или услуг, которые требуют обновления подходов к обработке
          персональных данных;
        </li>
        <li>
          обратная связь от пользователей или изменения в политике конфиденциальности партнёров
          Оператора.
        </li>
      </ul>
      <p className={styles.paragraph}>
        Оператор будет направлять уведомления об изменениях Политики в случае, если такие изменения
        являются существенными, доступными способами.
      </p>
    </section>
  </DocumentPage>
)

export default PrivacyPage
